export default __webpack_public_path__ + "static/media/screenshot_step2_3b_purple.03cb7610.png";